import React from "react";

class TranscodedVideoPlayer extends React.Component {
    videoRef = React.createRef();
    ffmpeg = null;
    state = { loading: false, error: null };

    componentDidMount() {
        this.loadAndTranscode();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
            this.loadAndTranscode();
        }
    }

    async loadAndTranscode() {
        const { src } = this.props;
        if (!src) return;

        this.setState({ loading: true, error: null });

        try {
            if (!window.FFmpegWASM) {
                throw new Error("FFmpeg script not loaded — check index.html script tag");
            }

            // if (!this.ffmpeg) {
            //     const { FFmpeg } = window.FFmpegWASM;
            //     this.ffmpeg = new FFmpeg();
            //     const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd";
            //     await this.ffmpeg.load({
            //         coreURL: `${baseURL}/ffmpeg-core.js`,
            //         wasmURL: `${baseURL}/ffmpeg-core.wasm`,
            //     });
            // }

            if (!this.ffmpeg) {
                const { FFmpeg } = window.FFmpegWASM;
                this.ffmpeg = new FFmpeg();
                await this.ffmpeg.load({
                    coreURL: "/ffmpeg/ffmpeg-core.js",
                    wasmURL: "/ffmpeg/ffmpeg-core.wasm",
                });
            }

            const response = await fetch(src);
            const videoData = new Uint8Array(await response.arrayBuffer());
            await this.ffmpeg.writeFile("input.mp4", videoData);

            await this.ffmpeg.exec([
                "-i", "input.mp4",
                "-c:v", "libx264",
                "-preset", "ultrafast",
                "-crf", "23",
                "-c:a", "aac",
                "-movflags", "+faststart",
                "output.mp4",
            ]);

            const data = await this.ffmpeg.readFile("output.mp4");
            const blob = new Blob([data.buffer], { type: "video/mp4" });
            const blobUrl = URL.createObjectURL(blob);

            if (this.videoRef.current) {
                this.videoRef.current.src = blobUrl;
            }
            this.setState({ loading: false });
        } catch (err) {
            console.error("Transcode failed", err);
            this.setState({ loading: false, error: "Playback conversion failed" });
        }
    }

    componentWillUnmount() {
        if (this.videoRef.current?.src?.startsWith("blob:")) {
            URL.revokeObjectURL(this.videoRef.current.src);
        }
    }

    render() {
        const { loading, error } = this.state;
        return (
            <div style={{ position: "relative" }}>
                {loading && (
                    <div style={{ padding: 20, textAlign: "center", color: "#fff", background: "#000" }}>
                        Preparing video...
                    </div>
                )}
                {error && <div style={{ color: "red", padding: 10 }}>{error}</div>}
                <video
                    ref={this.videoRef}
                    autoPlay
                    muted
                    controls
                    playsInline
                    style={{ width: "100%", height: "500px", background: "#000", objectFit: "fill", maxHeight: "80%", display: loading ? "none" : "block" }}
                />
            </div>
        );
    }
}

export default TranscodedVideoPlayer;